export const environment = {
  production: true,
  //baseUrl: 'https://www.richdate.co.il',
  baseUrl: '',
  api: '/api/v1',
  displayBanner: true
};
